import classNames from "classnames";
import Styles from "./Card.module.scss";

const Card2 = ({ img, title, description, date, onClick }) => {
  return (
    <div className={Styles.card_2} onClick={onClick}>
      <div
        style={{
          backgroundImage: `url(${img})`,
          height: "34vh",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      ></div>
      <div className={Styles.card_2__content}>
        
        <div className={Styles.card_2__date}>{date}</div>
        <div className={Styles.card_2__title__wrapper}>
          <div className={Styles.card_2__title}>{title}</div>
        </div>

        <p className={Styles.card_2__description}>{description}</p>
      </div>
    </div>
  );
};

export default Card2;
